import React, { useState } from "react";
import styles from "./Settings.module.css";
import axios from "axios";

export default function AddReason() {
  const [reason, reasonSet] = useState("");
  const [showInput, showInputSet] = useState(false);

  const handleReasonChange = (e) => {
    reasonSet(e.target.value);
  };

  const handleShowInput = () => {
    showInputSet(!showInput);
  };

  const handleCancel = () => {
    reasonSet("");
    showInputSet(false);
  };

  const handleAccept = async () => {
    await axios
      .post(`https://nitrous.rt-itservices.co.uk/packers/reasons/add/${reason}`)
      .then(() => window.location.reload())
      .catch((e) => alert(e.message));
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) handleAccept();
  };

  return (
    <div className="">
      <div
        className={`${styles.add} pt-1 pb-1 pl-2 pr-2 mt-3 `}
        onClick={handleShowInput}>
        Add New Reason
      </div>
      {showInput ? (
        <div style={{ display: "inline-block" }} className="ml-3">
          <input
            value={reason}
            onChange={handleReasonChange}
            className="rounded"
            onKeyDown={handleKeyDown}
          />
          <span
            style={{ cursor: "pointer" }}
            className="ml-3"
            onClick={handleAccept}>
            ✔️
          </span>
          <span
            style={{ cursor: "pointer" }}
            className="ml-3"
            onClick={handleCancel}>
            ❌
          </span>
        </div>
      ) : null}
    </div>
  );
}
